import { Injectable } from "@angular/core";

export interface DownloadOptions {
  url: string;
  filename: string;
}

export interface DownloadResult {
  success: boolean;
  error?: string;
}

@Injectable({
  providedIn: "root",
})
export class FileDownloadService {
  /**
   * Downloads a file from a URL and triggers a browser download.
   * Uses a simple approach that works with pre-signed URLs and avoids CORS issues.
   *
   * @param options - The download options containing URL and filename
   * @returns Promise resolving to the download result
   */
  async downloadFile(options: DownloadOptions): Promise<DownloadResult> {
    const { url, filename } = options;

    try {
      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.target = "_blank";
      link.rel = "noopener noreferrer";

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return { success: true };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error occurred";
      return {
        success: false,
        error: errorMessage,
      };
    }
  }
}
